var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendNow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.205 7.70998H2.91967C2.91967 7.52664 2.88167 7.34331 2.80633 7.17131L1.22167 3.58597C0.715 2.43931 1.927 1.29131 3.04433 1.85864L12.2317 6.52131C13.205 7.01464 13.205 8.40531 12.2317 8.89864L3.045 13.5613C1.927 14.1286 0.715 12.98 1.22167 11.834L2.805 8.24864C2.87983 8.07892 2.91843 7.89546 2.91833 7.70998",
    stroke: "#10A37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNow);
export default __webpack_public_path__ + "static/media/send-now.0ac241271b0d4b937f8257bc842d3f46.svg";
export { ForwardRef as ReactComponent };